import React from 'react';

import {
  Form,
  Button,
  Typography,
  Row,
  Col,
  Select,
  DatePicker,
  Checkbox
} from 'antd';
import {
  mailTemplatesList,
  dateFormat,
  receivedEmailList
} from '../constant';

const { Title, Text } = Typography;
const { Option } = Select;

const CommunitiesEmailLogsForm = ({
  form,
  resetForm,
  onFinish,
  totalCount,
  communityList,
  withDate,
  setWithDate
}) => {
  return (
    <Form form={form} onFinish={onFinish}>
      <Row justify="space-between">
        <Title level={4}>Filters</Title>
        <Text strong>Total Count: {totalCount}</Text>
      </Row>

      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="mailCourse">
            <Select
              placeholder="Select Community Code"
              defaultValue={communityList?.[0]?.value}>
              {communityList?.map((option, index) => (
                <Option key={index} value={option?.value}>
                  {option?.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Text> Members that have </Text>
        <Col span={4}>
          <Form.Item name="received">
            <Select placeholder="Both">
              {receivedEmailList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="mailType">
            <Select placeholder="This email">
              {mailTemplatesList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col>
          <Checkbox
            checked={withDate}
            onChange={() => {
              setWithDate(!withDate);
            }}>
            Select dates
          </Checkbox>
        </Col>

        {withDate ? (
          <>
            <Col>
              <Form.Item name="startDate">
                <DatePicker
                  showTime={true}
                  showNow={false}
                  format={dateFormat}
                  style={{ width: '100%' }}
                  placeholder="Select Start Date"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item name="endDate">
                <DatePicker
                  showTime={true}
                  showNow={false}
                  format={dateFormat}
                  style={{ width: '100%' }}
                  placeholder="Select End Date"
                />
              </Form.Item>
            </Col>
          </>
        ) : null}
        <Col>
          <Button type="primary" htmlType="submit">
            Search
          </Button>
        </Col>
        <Col>
          <Button htmlType="button" onClick={resetForm}>
            Clear
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default CommunitiesEmailLogsForm;
